import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { C4PaymentMethodDetail } from '../../../api/http.service'
import { Subscriptions } from '../../../utils/subscriptions'
import { tap } from 'rxjs'
import { selectProfileState } from '../../../account/user-profile/user-profile.state'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'

@Component({
  selector: 'cover-change-payment-method-dialog',
  templateUrl: './change-payment-method-dialog.component.html',
  styleUrls: ['./change-payment-method-dialog.component.scss'],
})
export class ChangePaymentMethodDialogComponent implements OnInit {
  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  paymentMethodSelected?: C4PaymentMethodDetail
  c4SessionId: string = ''
  adrGr: string = ''
  personNr: number = 0

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: C4PaymentMethodDetail[],
    private readonly store: Store,
    private readonly dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<ChangePaymentMethodDialogComponent>,
  ) {}

  get shouldDisableButton(): boolean {
    return !this.paymentMethodSelected
  }

  ngOnInit(): void {
    this.subscriptions.plusOne = this.store
      .select(selectProfileState.customerSubNr)
      .pipe(
        tap(customerSubNr => {
          if (customerSubNr !== '') {
            this.personNr = customerSubNr as unknown as number
          }
        }),
      )
      .subscribe()

    this.subscriptions.plusOne = this.store
      .select(selectProfileState.adrGr)
      .pipe(
        tap(adrGr => {
          this.adrGr = adrGr
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = this.store
      .select(selectProfileState.c4SessionId)
      .pipe(
        tap(sessionId => {
          this.c4SessionId = sessionId
        }),
      )
      .subscribe()
  }

  markAsSelected(detail: C4PaymentMethodDetail): void {
    this.paymentMethodSelected = detail
  }

  saveChanges(): void {
    this.subscriptions.plusOne = this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'GENERAL.CONFIRM_DIALOG.TITLE',
          description: 'GENERAL.CONFIRM_DIALOG.DESCRIPTION',
        },
      })
      .afterClosed()
      .subscribe(shouldSaveChanges => {
        if (shouldSaveChanges) this.dialogRef.close(this.paymentMethodSelected)
      })
  }
}
